module.exports = __webpack_public_path__ + "media/assets/platinumFooter-da28d15c3a201da2010522ab44cd351c.png";